import { styled, makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Chip from '@material-ui/core/Chip'

export const ContactInfoItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(0),
  },
}))

export const InfoHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}))


export const ContactInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  marginRight: theme.spacing(2),
  marginTop: '80px',
  flexWrap: 'wrap',
  '& span': {
    marginRight: theme.spacing(3),
    color: 'black',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
    marginTop: '0px',
    '& div': {
      alignItems: 'center',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),

      '& svg': {
        height: '0.5em',
        width: '0.5em',
      },
    },
  },
}))

export const IconWrapper = styled(Box)(({ theme }) => ({
  width: '40px',
  minWidth: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: theme.palette.gold.main,
  marginRight: '0.75rem',
  [theme.breakpoints.down('sm')]: {
    width: '20px',
    minWidth: '20px',
    height: '20px',
  },
}))
export const CardIcon = styled(Box)(({ background, theme }) => ({
  width: '80px',
  height: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundImage: `url(${background})`,
  backgroundColor: theme.palette.common.white,
  backgroundPosition: 'center',
  backgroundSize: '60%',
  backgroundRepeat: 'no-repeat',
  border: `2px solid ${theme.palette.primary.light}`,
  position: 'absolute',
  top: '60px',
  right: '28px',
  [theme.breakpoints.down('sm')]: {
    width: '60px',
    height: '60px',
    top: '50px',
    right: '24px',
  },
}))

export const StoryImage = styled(Box)(({ theme, image }) => ({
  width: '100%',
  backgroundImage: `url(${image}?h=2000&w=3000&fl=progressive&q=80)`,
  minHeight: '400px',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  [theme.breakpoints.down('sm')]: {
    backgroundImage: `url(${image}?h=1333&w=2000&fl=progressive&q=80)`,
    minHeight: '240px',
    height: 'auto',
  },
}))

export const FilterChip = styled(Chip)(({ theme }) => ({
  borderRadius: '6px',
  color: `${theme.palette.secondary.main}`,
  fontWeight: '700',
  alignItems: 'center',
  display: 'flex',
  height: '45px',
  '&.is-active': {
    backgroundColor: `${theme.palette.primary.main}`,
    color: '#ffffff',
  },
}))


export const useStyles = makeStyles(theme => ({
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '190px',
    minWidth: '190px',
    height: '190px',
    backgroundColor: theme.palette.background.default,
    border: `7px solid ${theme.palette.common.white}`,
    filter: 'drop-shadow(0px 4px 36px rgba(0, 0, 0, 0.13))',
    borderRadius: '9px',
    marginTop: '-75px',
    marginRight: theme.spacing(5),
    position: 'relative',
    zIndex: '10',
    '& > img': {
      height: 'auto',
      maxWidth: '85%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '150px',
      minWidth: '150px',
      height: '150px',
      marginRight: '0px',
      '& > img': {
        width: '100px',
      },
    },
  },
  titleWrapper: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
  },
  titleBox: {
    marginBottom: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      marginBottom: theme.spacing(4),
    },
  },
  icon: {
    color: theme.palette.secondary.main,
    height: '18px',
    width: '18px',
  },
  caption: {
    fontWeight: '600',
    color: theme.palette.grey.dark,
    letterSpacing: '0',
  },
  outerContainer: ({ bgColor }) => ({
    backgroundColor: bgColor || theme.palette.primary.contrastText,
    padding: theme.spacing(0, 3, 12),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 0, 6),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1, 6),
    },
  }),
  offeringsOuterContainer: ({ bgColor }) => ({
    display: 'flex',
    backgroundColor: bgColor || theme.palette.primary.contrastText,
    padding: theme.spacing(10, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(6, 0),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 1),
    },
  }),
  upcomingEventsOuterContainer: {
    overflowX: 'hidden',
    padding: theme.spacing(8, 0, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(8, 1, 0),
    },
  },
  quickLinksContainer: {
    minWidth: '350px',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.primary.contrastText,
    boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.13)',
  },
  featuredImg: {
    width: '100%',
    maxHeight: '280px',
    objectFit: 'cover',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '210px',
    },
  },
  upcomingSection: () => ({
    backgroundColor: '#F5F7FA',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1.5rem 4.5rem 1.5rem',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
    },
  }),
  upcomingEventHeader: {
    margin: '4.5rem 0 1.5rem',
    [theme.breakpoints.down('sm')]: {
      margin: '1.75rem 0 0',
    },
  },
  upcomingHopeEventHeader: {
    margin: '3rem 1rem 1.5rem',
    [theme.breakpoints.down('sm')]: {
      margin: '1.75rem 0 0',
    },
  },
  upcomingHopeEventSubHeader: {
    margin: '0 1rem 1.5rem',
  },
  coachesSection: () => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1.5rem 1.5rem 1.5rem',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1),
    },
  }),
  groupEvent: {
    boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.13)',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  media: {
    height: 110,
  },
  chip: {
    position: 'absolute',
    top: '24px',
    left: '24px',
    backgroundColor: '#000000',
    color: '#ffffff',
    borderRadius: '6px',
  },
  cardSubtitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(6),
  },
  cardAction: {
    borderTop: '1px solid #D8D8D8',
    height: '50px',
  },
  ctaLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    color: theme.palette.blue.main,
    fontWeight: '700',
    fontSize: '16px',
    '&:hover': {
      color: theme.palette.blue.main,
    },
  },
  ctaArrow: {
    top: '0',
    color: theme.palette.blue.main,
  },
  paginationNumber: {
    fontFamily: 'Source Serif Pro',
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '0.02em',
    textAlign: 'center',
    color: theme.palette.grey.dark,
    padding: theme.spacing(1),
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
  },
  sectionHeading: {
    margin: '4.5rem 0',
    [theme.breakpoints.down('sm')]: {
      margin: '1.5rem 0 0',
    },
  },
  nonSliderEventsWrapper: {
    margin: '1.25rem 0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventsWrapper: {
    paddingBottom: '1rem',
    '& .slick-slide': {
      padding: '28px 14px 0',
    },
    '& .slick-list': {
      margin: '0 auto',
      width: 'calc( 100% + 28px)',
      marginLeft: '-14px',
    },
    '& .slick-dots': {
      bottom: '-38px', // this pushes the nav numbers down
    },
    '& .slick-dots li': {
      width: '40px',
      height: '40px',
      margin: '0',
    },
    '& .slick-active > a': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.contrastText,
    },
    '& .slick-next': {
      display: 'none!important',
    },
    '& .slick-prev': {
      display: 'none!important',
    },
  },
  eventsWrapperCenter: {
    '& .slick-slide:first-child > div': {
      float: 'right',
    },
    '& .slick-slide > div': {
      width: '410px',
    },
  },
  singleEventWrapperCenter: {
    '& .slick-slide > div': {
      width: '410px',
      margin: '0 auto',
    },
  },
  eventCardHorizontal: {
    padding: '0',
    flexDirection: 'row',
  },
  eventCard: {
    marginBottom: '1.5rem',
  },
  slider: {
    '& .keen-slider__slide > div': {
      scale: '1',
    },
  },
  customControl: {
    paddingBottom: '1.5rem',
    '& button': {
      width: '56px',
      height: '49px',
      background: '#FFFFFF',
      boxShadow: '0px 4.8px 60px rgba(0, 0, 0, 0.1)',
    },
  },
  contactLink: {
    fontWeight: 600,
  },
  quicklink: {
    color: theme.palette.secondary.dark,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: theme.palette.secondary.light,
    },
  },
  alignLeft: {
    justifyContent: 'flex-start',
  },

  gridContainer: {
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      minHeight: '33.125rem',
    },
  },
  overline: {
    color: theme.palette.grey.dark,
    lineHeight: '14px',
  },
  subtitle: {
    marginBottom: '3.125rem',
  },
  headerLine: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0',
      paddingBottom: '0',
      alignItems: 'center',
    },
  },
  storiesSection: {
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '530px',
    border: 0,
    margin: 0,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      height: '300px',
    },
  },
  quickLinksSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  quickLinksImage: {
    width: '100%',
    maxWidth: '400px',
    maxHeight: '350px',
    objectFit: 'contain',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem auto',
    },
  },
  infoImageWrapper: {
    margin: 'auto',
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      borderRadius: '8px',
      [theme.breakpoints.down('sm')]: {
        margin: '1rem auto',
      },
    },
  },
  quicklinkText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 700,
  },
  descriptionText: {
    paddingRight: '.75rem',
  },
  addressContactInfoItem: {
    width: '100%',
    justifyContent: 'flex-start',
  },
  markdownParagraph: {
    marginTop: theme.spacing(2),
  },
  descriptionSection: {
    paddingRight: '1rem',
  },
  controlClassName: {
    paddingBottom: '1.5rem',
  },
  offeringsOverline: {
    color: theme.palette.primary.dark,
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    letterSpacing: '1px',
  },
}))
